import * as Types from 'src/actions/project/team-member/create/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { RootState } from 'src/reducers/RootReducer';
import ProjectTeamMember from 'src/value-objects/ProjectTeamMembers';

export interface CreateProjectTeamMemberAttempt extends Action {
  type: Types.CREATE_PROJECT_TEAM_MEMBER_ATTEMPT;
}

export interface CreateProjectTeamMemberSuccess extends Action {
  type: Types.CREATE_PROJECT_TEAM_MEMBER_SUCCESS;
  payload: ProjectTeamMember;
}

export interface CreateProjectTeamMemberFailure extends Action {
  type: Types.CREATE_PROJECT_TEAM_MEMBER_FAILURE;
  payload: {};
}

export type CreateProjectTeamMemberAction =
  CreateProjectTeamMemberAttempt
  | CreateProjectTeamMemberSuccess
  | CreateProjectTeamMemberFailure;

export interface CreateProjectTeamMemberThunk extends ThunkAction<Promise<CreateProjectTeamMemberAction>,
  RootState, string> {
}

export const createProjectTeamMemberAttempt: ActionCreator<CreateProjectTeamMemberAttempt> = () => (
  {
    type: Types.CREATE_PROJECT_TEAM_MEMBER_ATTEMPT
  }
);

export const createProjectTeamMemberSuccess: ActionCreator<CreateProjectTeamMemberSuccess> =
  (teamMember: ProjectTeamMember) => ({
      type: Types.CREATE_PROJECT_TEAM_MEMBER_SUCCESS,
      payload: teamMember
    }
  );

export const createProjectTeamMemberFailure: ActionCreator<CreateProjectTeamMemberFailure> = (error: {}) => (
  {
    type: Types.CREATE_PROJECT_TEAM_MEMBER_FAILURE,
    payload: error
  }
);

export const createProjectTeamMember: ActionCreator<CreateProjectTeamMemberThunk> =
  (id: string, teamMember: ProjectTeamMember): CreateProjectTeamMemberThunk => {
    return (dispatch: Dispatch<RootState>): Promise<CreateProjectTeamMemberAction> => {
      dispatch(createProjectTeamMemberAttempt());

      return ApiClient.projectTeamMember.create(teamMember, {projectId: id})
        .then((response): CreateProjectTeamMemberSuccess => {
          return dispatch(createProjectTeamMemberSuccess(response.data.content));
        }).catch((): CreateProjectTeamMemberFailure => {
          return dispatch(createProjectTeamMemberFailure());
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/team-member/create/CreateProjectTeamMember.actions.tsx